import styled from 'styled-components'

export const CheckboxLabel = styled.label`
  align-items: center;
  align-self: flex-start;
  display: flex;
  line-height: 1;
  margin-bottom: 1rem;
  position: relative;
`

export const InputCheckbox = styled.input`
  border: 1px solid red;
  opacity: 0;
  width: 0;
  height: 0;
  margin: 0;

  & ~ span {
    color: ${({ theme }) => theme.colors.textColor};
    padding-left: 1.5rem;
  }

  & ~ svg {
    font-size: 1.125rem;
    line-height: 1;
    position: absolute;
    top: -3px;
    left: 0;
  }

  & ~ svg[data-icon='check-square'] {
    color: ${({ theme }) => theme.colors.inverseColor};
    display: none;
  }

  & ~ svg[data-icon='square'] {
    color: ${({ isValid, theme }) => (isValid ? '#b2b2b2' : `${theme.colors.formErrorColor}`)};
  }

  &:focus {
    & ~ svg {
      outline-color: -webkit-focus-ring-color;
      outline-style: auto;
    }
  }

  &:checked {
    & ~ svg[data-icon='square'] {
      display: none;
    }

    & ~ svg[data-icon='check-square'] {
      display: block;
    }
  }
`
